<template>
    <v-tab-item :value="Liquid.value">
        <v-container>
            <top-image :tit="Liquid.text" bgImage="/images/sub/product/liquid-bg.jpg" image="/images/sub/product/liquid-img.png">
                <p class="page-text mb-6 mb-lg-20">
                    We provide Liquid Analyzer System that is designed to provide accurate and reliable measurements of key parameters such as pH, ORP, Conductivity, TOC, Chlorine, Ammonia, and Dissolved oxygen.
                </p>
                <p class="page-text mb-6 mb-lg-20">
                    Liquid analysis is essential for protecting vital capital assets such as boilers and cooling towers by preventing corrosion, minimizing maintenance, and maximizing uptime. Our system allows you to continuously monitor the chemistry of your process liquid and make adjustments as needed to maintain optimal performance.
                </p>
                <p class="page-text">
                    The system is highly customizable and can be tailored to meet the specific needs of your application. It can be used in a wide range of industries such as power generation, water treatment, and chemical processing.
                </p>
            </top-image>
        </v-container>
    </v-tab-item>
</template>

<script>
import TopImage from "@/components/dumb/top-image.vue";
import { Product_TABS } from "@/assets/variables";
const { Liquid } = Product_TABS;
export default {
    components: {
        TopImage,
    },
    data() {
        return {
            Liquid,
        };
    },
};
</script>

<style scoped></style>
